import { heavyCalcHandlers, } from './handlers.js';
// undefined: not attempted yet, null: unavailable (falls back to main thread)
let worker;
const pending = new Map();
let nextId = 0;
const toError = (serialized) => Object.assign(new Error(serialized.message), serialized);
const runOnMainThread = (p) => Promise.resolve().then(p.fallback).then(p.resolve, p.reject);
const failover = (reason, cause) => {
    if (worker == null) {
        return;
    }
    // Results stay correct on the main thread, but heavy cases block the UI
    reportError(new Error(`Heavy-calculation worker unavailable, falling back to the main thread: ${reason}`, { cause }));
    worker.terminate();
    worker = null;
    for (const [id, p] of pending) {
        pending.delete(id);
        runOnMainThread(p);
    }
};
const getWorker = () => {
    if (worker !== undefined) {
        return worker;
    }
    try {
        if (typeof Worker === 'undefined') {
            worker = null;
            return worker;
        }
        const w = new Worker(new URL('./calc.worker.js', import.meta.url), {
            type: 'module',
        });
        w.onmessage = (e) => {
            if (e.data.id === undefined) {
                failover('its modules failed to load', toError(e.data.error));
                return;
            }
            const p = pending.get(e.data.id);
            if (p == null) {
                return;
            }
            pending.delete(e.data.id);
            if (e.data.error != null) {
                p.reject(toError(e.data.error));
            }
            else {
                p.resolve(e.data.result);
            }
        };
        w.onerror = (e) => {
            // Reported by failover; uncancelled it would also surface on the window
            e.preventDefault();
            failover(e.message || 'worker failed to load');
        };
        w.onmessageerror = () => failover('a response could not be deserialized');
        worker = w;
    }
    catch (error) {
        reportError(error);
        worker = null;
    }
    return worker;
};
const call = (method, args) => new Promise((resolve, reject) => {
    const p = {
        resolve: resolve,
        reject,
        fallback: () => heavyCalcHandlers[method](...args),
    };
    const w = getWorker();
    if (w == null) {
        runOnMainThread(p);
        return;
    }
    const id = nextId++;
    pending.set(id, p);
    try {
        // Web Worker postMessage does not accept a window targetOrigin.
        // oxlint-disable-next-line unicorn/require-post-message-target-origin
        w.postMessage({ id, method, args });
    }
    catch (error) {
        reportError(error);
        pending.delete(id);
        runOnMainThread(p);
    }
});
export const workerHeavy = Object.fromEntries(Object.keys(heavyCalcHandlers).map((method) => [
    method,
    (...args) => call(method, args),
]));
//# sourceMappingURL=worker-client.js.map